import { render, staticRenderFns } from "./zsjgl.vue?vue&type=template&id=839dc32a&scoped=true&"
import script from "./zsjgl.vue?vue&type=script&lang=js&"
export * from "./zsjgl.vue?vue&type=script&lang=js&"
import style0 from "./zsjgl.vue?vue&type=style&index=0&id=839dc32a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839dc32a",
  null
  
)

export default component.exports